export default "__VITE_ASSET__DBFlD2dq__"